import axios from 'axios'
import analytics, { EVENTS } from '@/plugins/analytics'

export default {
  namespaced: true,
  state: {
    jwt: null
  },
  getters: {
    /*id: (state) => {
      return JSON.parse(atob(state.jwt.split('.')[1])).id;
    }*/
  },
  mutations: {
    login(state, token) {
      state.jwt = token
    },
    logout(state) {
      state.jwt = null
    }
  },
  actions: {
    login({ commit }, { email, password }) {
      return new Promise(async (resolve, reject) => {

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/login`, {
            email,
            password
          })
          if (response.status == 200) {

            if (response.data.company_type == "location") {
              this.state.auth.is_location = true;
            }
            else {
              this.state.auth.is_location = false;
            }

            commit('login', response.data.token)
            analytics.capture(EVENTS.LOGGED_IN, { email })
            resolve()
            return;
          }
        } catch (error) {
          reject(error.response.data.message)
          return
        }

        reject()

      })
    },
    signup({ commit }, payload) {
      return new Promise(async (resolve, reject) => {

        try {
          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/register`, payload)
          if (response.status == 200) {
            resolve()
            commit('login', response.data.token);
            // Identify the new person with their email so the anonymous signup-page
            // session ties to a known user, then tag the signup event itself.
            analytics.identify(response.data.user);
            analytics.capture(EVENTS.SIGNED_UP, {
              email: payload.email,
              company_type: payload.company_type,
              plan: payload.selected_plan ? payload.selected_plan.code : null
            });

            return;
          }
        } catch (error) {
          //console.log(error.response.data.message)
          reject(error.response.data)
          return
        }

        reject()

      })
    },
    logout({ commit }) {
      analytics.reset()
      commit('logout')
    }
  }
}